module.exports = __webpack_public_path__ + "static/media/Sizex Clin Logo.adb93f64.png";